export default __webpack_public_path__ + "static/media/verticalOrientation.6c21d242.png";